export const getTimeZone = () => {
	return Intl ? Intl.DateTimeFormat().resolvedOptions().timeZone : "Africa/Cairo";
};
